import { FlagShortPole } from '@/assets/icons'
import { MenuItem } from '@/components/menu/MenuItem'
import { RuntimeFeatureFlag } from '@/feature-flags/definitions'
import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'

/**
 * Internal canary for runtime flags, shown only to Paxton accounts with `posthog-demo` enabled.
 * Flipping the flag in PostHog shows or hides the item to prove the API-to-browser path.
 */
export function PostHogDemoMenuItem({ onSelect }: { onSelect: () => void }) {
  const { enabled, loading } = useRuntimeFeatureFlag(RuntimeFeatureFlag.POSTHOG_DEMO)
  if (loading || !enabled) return null
  return <MenuItem label="PostHog demo" subheading="Flag on" icon={FlagShortPole} onSelect={onSelect} />
}
